import React, { useState } from 'react';
import './MedicalVeterinary.css'; // Ensure your CSS file is properly linked
import medicalImage from '../assets/img/medical.jpg';  // Ensure path is correct
import veterinaryImage from '../assets/img/veterinary.jpg'; // Ensure path is correct

const MedicalVeterinary = () => {
  const [activeTab, setActiveTab] = useState('medical');

  return (
    <div className="medical-veterinary-container">
      <div className="tab-buttons">
        <button
          className={activeTab === 'medical' ? 'active' : ''}
          onClick={() => setActiveTab('medical')}
        >
          Medical
        </button>
        <button
          className={activeTab === 'veterinary' ? 'active' : ''}
          onClick={() => setActiveTab('veterinary')}
        >
          Veterinary
        </button>
      </div>

      <div className="service-content">
        <h2 className="service-header">{activeTab === 'medical' ? 'Medical Services' : 'Veterinary Services'}</h2>
        <div class="ser-thermal-line"></div>

        {activeTab === 'medical' ? (
          <div className="medical-service-container">
            <div className="medical-text-container">
              <p>
                We offer a full range of healthcare services including diagnostics, treatment, and wellness checks for all age groups.
              </p>
            </div>
            <div className="medical-image-container">
              <img src={medicalImage} alt="Medical Services" /> {/* Ensure this is the medical image */}
            </div>
          </div>
        ) : (
          <div className="veterinary-service-container">
            <div className="veterinary-text-container">
              <p>
                Our veterinary clinic provides expert care for your pets, including vaccinations, surgeries, and preventive health.
              </p>
            </div>
            <div className="veterinary-image-container">
              <img src={veterinaryImage} alt="Veterinary Services" /> {/* Ensure this is the veterinary image */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MedicalVeterinary;
